export default "__VITE_ASSET__BNAkNVA2__"